import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProductCartList, adaptAccountProductCartIdListToRequest, adaptProductCartFromListResponse } from 'src/store';

import { useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_PRODUCT_CART } from '../../backend-paths';


export const accountProductCartListDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ACCOUNT_PRODUCT_CART}`,
	(payload: number[], thunkApi) => {
		const path = `${BACKEND_ACCOUNT_PRODUCT_CART}/delete`;
		const dataRequest = adaptAccountProductCartIdListToRequest(payload);

		return HttpService.post(path, dataRequest).then(result => {
			return adaptProductCartFromListResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list?: TProductCartList;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: undefined,
	error: undefined,
};

export const accountProductCartListDeleteSlice = createSlice({
	name: 'accountProductCartListDeleteSlice',
	initialState,
	reducers: {
		clearAccountProductCartListDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProductCartListDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProductCartListDeleteApi.fulfilled.type]: (state, action: PayloadAction<TProductCartList>) => {
			state.isLoading = false;
			state.list = action.payload;
		},

		[accountProductCartListDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProductCartListDeleteSelector = () => useAppSelector(state => state[accountProductCartListDeleteSlice.name]);

export const { clearAccountProductCartListDelete } = accountProductCartListDeleteSlice.actions;
